import React, { Component, PropTypes } from 'react';
import { DataStoreDispatcher } from '../../../../lib/frankly';

let didVuukleScriptLoad = false;

class Vuukle extends Component {
  static propTypes = {
    apiKey: PropTypes.string.isRequired,
    color: PropTypes.string,
    languageCode: PropTypes.string
  };

  static contextTypes = {
    config: PropTypes.object.isRequired,
    flux: PropTypes.object.isRequired
  }

  static defaultProps = {
    color: '#44c8e4',
    languageCode: 'en'
  }

  componentDidMount() {
    const {
      color,
      apiKey,
      languageCode
    } = this.props;

    const {
      flux,
      config: {
        integrations: {
          frankly: {
            franklyGoogleAnalyticsIdForAffiliate: GACode = ''
          } = {}
        } = {}
      } = {}
    } = this.context;

    const metas = flux.getStore('Helmet').getState().metas;

    if (!didVuukleScriptLoad && window && document) {
      const vuukleScript = document.createElement('script');
      vuukleScript.type = 'text/javascript';
      vuukleScript.src = 'https://vuukle.com/js/vuukle.js';
      document.body.appendChild(vuukleScript);
      didVuukleScriptLoad = true;
      window.addEventListener('load', () => {
        this.loadVuukle(color, apiKey, languageCode, metas, GACode);
      });
    }
  }

  loadVuukle(color, apiKey, languageCode, metas, GACode) {
    const createVuuklePlatform = window['create_vuukle_platform'];
    const metasObj = {};

    const franklyDataLayer = window['franklyDataLayer'] || [{}];
    const [{ feature_id: featureId, author: featureAuthor }] = franklyDataLayer;

    if (createVuuklePlatform !== 'undefined') {
      metas.forEach(meta => {
        const {
          name: metaName = '',
          property = '',
          content = ''
        } = meta;
        const name = metaName || property;

        if (['og:title', 'keywords'].indexOf(name) !== -1) {
          metasObj[name] = content;
        }
      });

      const {
        'og:title': title = '',
        keywords = ''
      } = metasObj;

      const articleDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/article');
      const articleId = articleDataStoreDispatcher.get('articleId') || featureId || '';
      const authorsString = articleDataStoreDispatcher.get('authors') || featureAuthor || '';
      const authors = authorsString.split(/,|&/);
      const vuukleAuthors = [];

      authors.forEach(author => {
        vuukleAuthors.push({name: author.trim()});
      });
      const encodedAuthor = btoa(encodeURI(JSON.stringify(vuukleAuthors)));

      createVuuklePlatform(
        apiKey,
        articleId,
        '0',
        keywords,
        title,
        languageCode,
        '1',
        '',
        GACode,
        color.substring(1),
        encodedAuthor
      );
    }
  }

  render() {
    return (
      <div >
        <div id="vuukle-emote"></div>
        <div id="vuukle_div"></div>
      </div>
    );
  }
}

export default Vuukle;



// WEBPACK FOOTER //
// ./app/components/custom/heartland/thirdParty/Vuukle.js